export const DataFormatter = (data, type) => {
  let tempData = data;
  let count = 0;
  if (tempData.length > 0) {
    tempData.forEach(data => {
      data.key = count++;
    });
  } else if(tempData.length <= 0 && type == "relatedDonor") {
      tempData = [{ name: "", relationship: "", key: 0}]
  }
  return tempData;
};
